GP.vent.on('init_js:search:quicksearch', _init_search);
GP.vent.on('init_js:search:viewed', _init_search);
// GP.vent.on('Search:setup_choose_interests_modal', _setup_choose_interests_modal);
// GP.vent.on('Search:interests_changed', _search_handle_interests_change);
let initial_search_state = {};
let changed_inputs = {};
let remove_me = {};

function _init_search(self) {
    var search_location_type;
    var show_rate_pic = (GP.sdata.my_user.membership == 'FREE') ? 1 : 0;

    self.handle_rating = function(id, score, picnum, success_callback){
        var actual_score = score * 2;
        if (picnum !== ''){
            $.post('/members/user/rate_user_pic/', {
                duid: id,
                pic_num:picnum,
                score:actual_score
            },
            function(data){
                if (!data.status && data.redirect !== undefined){
                    window.location.replace = data.redirect;
                } else if (typeof(success_callback) !== 'undefined'){
                    success_callback.apply(self);
                }
            });
        } else {
            success_callback.apply(self);
        }
    };

    self.handle_like = function(duid, gender, content_id, success_callback) {
        if (typeof content_id != 'undefined' && content_id){
            $.post('/members/content/add_free_like/', {
                duid: duid,
                gender: gender,
                content_id: content_id
            },
            function(data){
                if (data.error) {
                    _.each(data.error, function(err) {
                        if (GP.Util.check_obj(err) && err == 'billing_required') {
                            vent.trigger('Unlock:need_credits_modal');
                        }
                    });
                } else if (!data.status && typeof data.redirect !== 'undefined'){
                    GP.vent.trigger("Page:billing_redirect", duid);
                } else if (typeof(success_callback) !== 'undefined'){
                    success_callback.apply(self);
                }
            });
        } else {
            success_callback.apply(self);
        }
    };

    self.ps_show_advanced = function() {
       if (!ps_advanced_search) { return; }
        if (ps_advanced_search.css('display') == 'none') {
            if ($.browser.msie) {
                ps_advanced_search.css('display', 'block');
            } else {
                ps_advanced_search.css('display', 'table-row');
            }
            ps_advanced_state = 1;
        } else {
            ps_advanced_search.css('display', 'none');
            ps_advanced_state = 0;
        }
    };

    self.ps_disable_advanced = function() {
        if (!ps_advanced_search) { return; }

        ps_advanced_search.css('display', 'none');
    };

    self.ps_enable_advanced = function() {
        if (!ps_advanced_search) { return; }

        if (ps_advanced_state) {
            if ($.browser.msie) {
                ps_advanced_search.css('display', 'block');
            } else {
                ps_advanced_search.css('display', 'table-row');
            }
        }
    };

    self.change_country = function() {
        var country = '';
        if (document.getElementById('country')){
            country = document.getElementById('country');
        } else if (document.getElementById('country_code')){
            country = document.getElementById('country_code');
        }
        if (!country) {
            return;
        }
        var country_code = country.options[country.selectedIndex].value;

        var loc_div  = document.getElementById('loc_div');
        var city_div = document.getElementById('city_div');

        var city_label = document.getElementById('city_label');

        var loc_label  = document.getElementById('loc_label');
        var loc_label2  = document.getElementById('loc_label2');
        var location_id    = document.getElementById('location_id');
        var city_name      = document.getElementById('city_name');
        if ( country_code == 'US') {
            city_name.value = '';
            search_location_type = 'local';

            city_div.style.display = 'none';
            loc_div.style.display  = 'block';

            if (loc_label && city_label) {
                city_label.style.display = 'none';
                loc_label.style.display  = 'block';
            }

            if ( loc_label2 ) {
                if ( country_code == 'US' ) {
                    loc_label2.innerHTML = language.city_or_zip;
                }
            }
        } else {
            location_id.value = '';
            search_location_type = 'intl';

            if ( loc_label2 ) {
                loc_label2.innerHTML = language.city_name;
            }

            city_div.style.display = 'block';
            loc_div.style.display  = 'none';

            if (loc_label && city_label) {
                city_label.style.display = 'block';
                loc_label.style.display  = 'none';
            }
        }
    };

    self.do_search = function() {
        var search_a       = document.getElementById('search_a');
        var search_form    = document.getElementById('search_form');
        var location_id    = document.getElementById('location_id');
        var city_name      = document.getElementById('city_name');

        if ( search_location_type == 'local' ) {
            search_a.value = 'search.quicksearch';
            city_name.value = '';
            search_form.submit();
        } else if ( search_location_type == 'intl' ) {
            search_a.value = 'search.intl_bridge';
            location_id.value = '';
            search_form.submit();
        } else {
            return false;
        }
    };

    self.show_search_box = function(search_box_id) {
        var quicksearch_box = document.getElementById('quicksearch_box');
        var username_search_box = document.getElementById('username_search_box');
        quicksearch_box.style.display = 'none';
        username_search_box.style.display = 'none';
        document.getElementById(search_box_id).style.display = 'block';
    };

    var _add_fav_el;
    self.search_add_favorite = function(duid, el) {
        _add_fav_el = el;
        call_remote('network.add_favorite', ['fuid=' + duid, 'from_search=1'], self.search_add_fav_callback, 'POST');
        return false;
    };

    self.search_add_fav_callback = function(data, args) {
        obj = $.parseJSON(data);
        $(_add_fav_el).replaceWith("<span>"+obj.addstatus+"</span>");
    };

    self.reset_search_type = function() {
        $('#advanced_hidden').val(0);
        $('#username_hidden').val(0);
        $('#search-main').removeClass('show-advanced-search');
        $('#search-main').removeClass('show-username-search');
    };

    self.handle_search_result_click = function(el, e) {
        if ($('html').hasClass('mobile') && (!$(e.target).closest('.no-follow').length)) {
            search_profile_link = el.find('.profile-link').attr('href');
            GP.vent.trigger('Page:redirect',search_profile_link);
        }
    };

    var render_partial = function(selector, value){
        return $(selector).html().replace(/\%d/g, value);
    };


    // hook up binds once DOM is ready
    $(function() {
        var loc_obj = {};
        // load template-specific js
        // search.quicksearch, search.newfaces, search.browse

        $('#country_code').change(function() {
            $('#location_id, #city_name').val('');
            var country_code = $(this).find('option:selected').val();
            if (country_code == 'US') {
                $('#loc_label').text(loc_label);
            } else {
                $('#loc_label').text(intl_loc_label);
            }
        });

        $('#city_name').typeahead({
            items: "all",
            minLength: 3,
            source: function(query, process) {
                var country_code = $('#country_code option:selected').val();
                return $.get('/members/geo/suggest_city/?jq=1&country_code='+country_code, { location_name: query }, function(data) {
                    loc_obj = {};
                    var names = [];
                    $.map(data, function(val, i) {
                        if (Boolean(val.desc)) {
                            loc_obj[val.desc] = val.location_id;
                            names.push(val.desc);
                        }
                    });
                    return process(names);
                });
            },
            updater: function(name) {
                $('#location_id').val(loc_obj[name]);
                update_changed_inputs('location_id', loc_obj[name]);
                return name;
            }
        });

        // if the user doesn't click the typeahead suggestion the location_id wont get set
        // try to set it on blur if the input has a valid zip code (doesn't work for city name)
        $('#city_name').blur(function() {
            var val = $(this).val();
            if (val.length) {
                $.each(loc_obj, function(location_desc, location_id) {
                    if (location_id == val) {
                        $('#location_id').val(location_id);
                    }
                });
            } else {
                $('#location_id').val('');
            }
        });

        $('#search-main').on("click", ".notify_add", function(e){
            e.preventDefault();
            var button = $(this);
            var cur_profile = $(this).closest('.result_table');
            var form_data = {};
            form_data.types = alert_types;
            form_data.alert_duid = cur_profile.data('duid');
            $.post('/members/network/mod_alerts/', form_data, function(data) {
                var overlay = cur_profile.find('.actions_overlay');
                if (data.status) {
                    $.post('/members/util/gte/', { path: 'web.activity_messages.'+js_module });

                    overlay.find('.icon').html('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M11.1,24.1h-5.5c-2,0-3.1,0-3.3-.2-.2-.2-.3-.3-.3-.6,0-.3.6-1.3,1.9-3.3,1.3-2.1,2.4-5.2,2.4-9.6s1-4.7,2.9-6.4c1.8-1.7,4.3-2.7,6.9-2.7s5.1,1,6.9,2.7c1.8,1.7,2.9,4,2.9,6.4,0,4.4,1.1,7.4,2.4,9.6,1.3,2.1,1.9,3.1,1.9,3.3,0,.3,0,.4-.3.6-.2.2-1.2.2-3.3.2h-5.5M11.1,24.1v1.6c0,2.7,2.2,4.9,4.9,4.9s4.9-2.2,4.9-4.9v-1.6M11.1,24.1h9.7"></path></svg>');
                    overlay.find('.title').html('Notifications');
                    overlay.find('.actions_overlay_content').html($("#fragment_notify_add").html());
                    button.find('span').text(language.search_notified);
                    button.removeClass('notify_add').addClass('disabled').unbind('click');
                } else {
                    if (data.error == 'max_free') {
                        overlay.find('.icon').html('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M11.1,24.1h-5.5c-2,0-3.1,0-3.3-.2-.2-.2-.3-.3-.3-.6,0-.3.6-1.3,1.9-3.3,1.3-2.1,2.4-5.2,2.4-9.6s1-4.7,2.9-6.4c1.8-1.7,4.3-2.7,6.9-2.7s5.1,1,6.9,2.7c1.8,1.7,2.9,4,2.9,6.4,0,4.4,1.1,7.4,2.4,9.6,1.3,2.1,1.9,3.1,1.9,3.3,0,.3,0,.4-.3.6-.2.2-1.2.2-3.3.2h-5.5M11.1,24.1v1.6c0,2.7,2.2,4.9,4.9,4.9s4.9-2.2,4.9-4.9v-1.6M11.1,24.1h9.7"></path></svg>');
                        overlay.find('.title').html('Notifications');
                        overlay.find('.actions_overlay_content').html(
                            render_partial('#fragment_notify_free_limit',alert_max_free)
                        );
                    } else {
                        overlay.find('.actions_overlay_content').html($("#fragment_error").html());
                    }
                }
                overlay.fadeIn(function() {
                    setTimeout(function() { overlay.hide(); }, 5000);
                });
            });
        });

        $('#search-main').on("click", ".add_fav", function(e){
            e.preventDefault();
            var button = $(this);
            var cur_profile = $(this).closest('.result_table');
            var form_data = {'fuid' : cur_profile.data('duid'), 'from_search': 1};
            $.post('/members/network/add_favorite/', form_data, function(data) {
                var overlay = cur_profile.find('.actions_overlay');
                if (data.redirect) {
                    GP.vent.trigger('Page:redirect', data.redirect);
                } else {
                    if (data.status) {
                        $.post('/members/util/gte/', { path: 'web.activity_messages.'+js_module });
                        overlay.find('.icon').html('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M5.1,7c0-1.7,0-2.6.3-3.3.3-.6.8-1.1,1.4-1.4.7-.3,1.5-.3,3.3-.3h11.8c1.7,0,2.6,0,3.3.3.6.3,1.1.8,1.4,1.4.3.7.3,1.5.3,3.3v23l-10.9-7.8-10.9,7.8V7Z"/></svg>');
                        overlay.find('.title').text('Favorites');
                        overlay.find('.actions_overlay_content').html($("#fragment_favorited").html());
                        button.find('span').text(language.search_favorited);
                        button.removeClass('add_fav').addClass('disabled').unbind('click');
                    } else {
                        overlay.find('.actions_overlay_content').html($("#fragment_error").html());
                    }
                    overlay.fadeIn(function() {
                        setTimeout(function() { overlay.hide(); }, 5000);
                    });
                }
            });
        });

        $('#search-main').on("click", ".add_favorite_viewed", function(e){
            e.preventDefault();

            var $ele = $(this);
            var fuid = $ele.data('duid');
            var form_data = {'fuid' : fuid, 'from_search': 1};
            $.post('/members/network/add_favorite/', form_data, function(data) {
                $ele.replaceWith("<span>"+data.addstatus+"</span>");
            });
        });

        $('#search-main').on("click", ".quick_chat", function(e){
            e.preventDefault();
            var cur_profile = $(this).closest('.result_table');
            var _username = $(this).closest('.search-result-content').data('username');
            var overlay = cur_profile.find('.actions_overlay');
            overlay.addClass('overlay-send-chat');
            overlay.find('.icon').html('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"><path d="M6.09436 11.2288C6.03221 10.8282 5.99996 10.4179 5.99996 10C5.99996 5.58172 9.60525 2 14.0526 2C18.4999 2 22.1052 5.58172 22.1052 10C22.1052 10.9981 21.9213 11.9535 21.5852 12.8345C21.5154 13.0175 21.4804 13.109 21.4646 13.1804C21.4489 13.2512 21.4428 13.301 21.4411 13.3735C21.4394 13.4466 21.4493 13.5272 21.4692 13.6883L21.8717 16.9585C21.9153 17.3125 21.9371 17.4895 21.8782 17.6182C21.8266 17.731 21.735 17.8205 21.6211 17.8695C21.4911 17.9254 21.3146 17.8995 20.9617 17.8478L17.7765 17.3809C17.6101 17.3565 17.527 17.3443 17.4512 17.3448C17.3763 17.3452 17.3245 17.3507 17.2511 17.3661C17.177 17.3817 17.0823 17.4172 16.893 17.4881C16.0097 17.819 15.0524 18 14.0526 18C13.6344 18 13.2237 17.9683 12.8227 17.9073M7.63158 22C10.5965 22 13 19.5376 13 16.5C13 13.4624 10.5965 11 7.63158 11C4.66668 11 2.26316 13.4624 2.26316 16.5C2.26316 17.1106 2.36028 17.6979 2.53955 18.2467C2.61533 18.4787 2.65322 18.5947 2.66566 18.6739C2.67864 18.7567 2.68091 18.8031 2.67608 18.8867C2.67145 18.9668 2.65141 19.0573 2.61134 19.2383L2 22L4.9948 21.591C5.15827 21.5687 5.24 21.5575 5.31137 21.558C5.38652 21.5585 5.42641 21.5626 5.50011 21.5773C5.5701 21.5912 5.67416 21.6279 5.88227 21.7014C6.43059 21.8949 7.01911 22 7.63158 22Z"/></svg>');
            overlay.find('.title').text('Quick Chat');
            overlay.find('.actions_overlay_content').html($('#fragment_quick_chat').html());
            overlay.find('.text-username').text(_username);
            overlay.find('form input[name="fduid"]').val(cur_profile.data('duid'));
            overlay.fadeIn();
        });

        $('#search-main').on("change", "#quick-chat-select", function(e){
            e.preventDefault();
            var cur_profile = $(this).closest('.result_table');
            var duid = cur_profile.data('duid');
            var overlay = $("#actions_overlay_" + duid);

            overlay.find('.form-group-select').removeClass('has-error');

            if ($(this).val() === 'custom') {
                overlay.addClass('overlay-send-chat');
                overlay.find('.btn-wrap').hide();
                overlay.find('.quick-message-wrap').html($('#fragment_send_message').html());
                overlay.find('.quick-message-wrap').show();
                overlay.find('form input[name="to_duid"]').val(duid);
                overlay.fadeIn();
                overlay.find('textarea').focus();
            } else {
                overlay.find('.quick-message-wrap').hide();
                overlay.find('.btn-wrap').show();
            }
        });

        $('.actions_overlay').delegate('.quick_chat_form', 'submit', function(e) {
            e.preventDefault();
            var form_data = $(this).serialize();
            var cur_profile = $(this).closest('.result_table');
            var button = cur_profile.find('.quick_chat');
            var overlay = cur_profile.find('.actions_overlay');
            var quick_chat_val = cur_profile.find('#quick-chat-select').val();

            if (quick_chat_val == null) {
                // prompt user to select a quick chat.
                cur_profile.find('.form-group-select').addClass('has-error');
            } else {
                // send the message
                $.post('/members/msg/send_quick_chat/', form_data, function(data) {
                    if (data.status) {
                        $.post('/members/util/gte/', { path: 'web.activity_messages.'+js_module });
    
                        overlay.find('.icon').html('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"><path d="M6.09436 11.2288C6.03221 10.8282 5.99996 10.4179 5.99996 10C5.99996 5.58172 9.60525 2 14.0526 2C18.4999 2 22.1052 5.58172 22.1052 10C22.1052 10.9981 21.9213 11.9535 21.5852 12.8345C21.5154 13.0175 21.4804 13.109 21.4646 13.1804C21.4489 13.2512 21.4428 13.301 21.4411 13.3735C21.4394 13.4466 21.4493 13.5272 21.4692 13.6883L21.8717 16.9585C21.9153 17.3125 21.9371 17.4895 21.8782 17.6182C21.8266 17.731 21.735 17.8205 21.6211 17.8695C21.4911 17.9254 21.3146 17.8995 20.9617 17.8478L17.7765 17.3809C17.6101 17.3565 17.527 17.3443 17.4512 17.3448C17.3763 17.3452 17.3245 17.3507 17.2511 17.3661C17.177 17.3817 17.0823 17.4172 16.893 17.4881C16.0097 17.819 15.0524 18 14.0526 18C13.6344 18 13.2237 17.9683 12.8227 17.9073M7.63158 22C10.5965 22 13 19.5376 13 16.5C13 13.4624 10.5965 11 7.63158 11C4.66668 11 2.26316 13.4624 2.26316 16.5C2.26316 17.1106 2.36028 17.6979 2.53955 18.2467C2.61533 18.4787 2.65322 18.5947 2.66566 18.6739C2.67864 18.7567 2.68091 18.8031 2.67608 18.8867C2.67145 18.9668 2.65141 19.0573 2.61134 19.2383L2 22L4.9948 21.591C5.15827 21.5687 5.24 21.5575 5.31137 21.558C5.38652 21.5585 5.42641 21.5626 5.50011 21.5773C5.5701 21.5912 5.67416 21.6279 5.88227 21.7014C6.43059 21.8949 7.01911 22 7.63158 22Z"/></svg>');
                        overlay.find('.title').text('Quick Chat');
                        overlay.find('.actions_overlay_content').html($('#fragment_quick_chat_sent').html());
                        button.find('.span').text(language.search_quick_chatted);
                        button.removeClass('quick_chat').addClass('disabled').unbind('click');
                    } else {
                        if (data.errors == 'hit free limit') {
                            overlay.find('.icon').html('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"><path d="M6.09436 11.2288C6.03221 10.8282 5.99996 10.4179 5.99996 10C5.99996 5.58172 9.60525 2 14.0526 2C18.4999 2 22.1052 5.58172 22.1052 10C22.1052 10.9981 21.9213 11.9535 21.5852 12.8345C21.5154 13.0175 21.4804 13.109 21.4646 13.1804C21.4489 13.2512 21.4428 13.301 21.4411 13.3735C21.4394 13.4466 21.4493 13.5272 21.4692 13.6883L21.8717 16.9585C21.9153 17.3125 21.9371 17.4895 21.8782 17.6182C21.8266 17.731 21.735 17.8205 21.6211 17.8695C21.4911 17.9254 21.3146 17.8995 20.9617 17.8478L17.7765 17.3809C17.6101 17.3565 17.527 17.3443 17.4512 17.3448C17.3763 17.3452 17.3245 17.3507 17.2511 17.3661C17.177 17.3817 17.0823 17.4172 16.893 17.4881C16.0097 17.819 15.0524 18 14.0526 18C13.6344 18 13.2237 17.9683 12.8227 17.9073M7.63158 22C10.5965 22 13 19.5376 13 16.5C13 13.4624 10.5965 11 7.63158 11C4.66668 11 2.26316 13.4624 2.26316 16.5C2.26316 17.1106 2.36028 17.6979 2.53955 18.2467C2.61533 18.4787 2.65322 18.5947 2.66566 18.6739C2.67864 18.7567 2.68091 18.8031 2.67608 18.8867C2.67145 18.9668 2.65141 19.0573 2.61134 19.2383L2 22L4.9948 21.591C5.15827 21.5687 5.24 21.5575 5.31137 21.558C5.38652 21.5585 5.42641 21.5626 5.50011 21.5773C5.5701 21.5912 5.67416 21.6279 5.88227 21.7014C6.43059 21.8949 7.01911 22 7.63158 22Z"/></svg>');
                            overlay.find('.title').text('Quick Chat');
                            overlay.find('.actions_overlay_content').html(
                                render_partial('#fragment_activity_limit',daily_activity_max)
                            );
                        } else {
                            overlay.find('.actions_overlay_content').html($('#fragment_error').html());
                        }
                    }
                    setTimeout(function() { overlay.hide().removeClass('overlay-send-chat'); }, 5000);
                });
            }
        });

        $('#search-main').on("click", ".send_wink", function(e){
            e.preventDefault();
            var button = $(this);
            var cur_profile = $(this).closest('.result_table');
            var form_data = {'fduid' : cur_profile.data('duid')};
            $.post('/members/msg/send_wink/', form_data, function(data) {
                var overlay = cur_profile.find('.actions_overlay');
                if (data.redirect) {
                    GP.vent.trigger('Page:redirect', data.redirect);
                } else {
                    $.post('/members/util/gte/', { path: 'web.activity_messages.'+js_module });

                    overlay.find('.actions_overlay_content').html($("#fragment_wink_sent").html());
                    button.find('span').text(language.search_winked);
                    button.removeClass('send_wink').addClass('disabled').unbind('click');

                    overlay.fadeIn(function() {
                        setTimeout(function() { overlay.hide(); }, 5000);
                    });
                }
            });
        });

        $('.search-result .btn-media-like').on('click', function() {
            var $ele = $(this);

            if ($ele.hasClass('liked')) {
                return;
            }

            var user_data = $ele.closest('div.result_table');
            var duid = user_data.data('duid');
            var gender = user_data.data('gender');
            var content_id = user_data.data('content-id');

            if (duid && content_id) {
                self.handle_like(duid, gender, content_id, function() {
                    $ele.addClass('liked').css('cursor', 'default');
                });
            }
        });

        $('.search-result .btn-send-message').on('click', function(e) {
            e.preventDefault();
            var $ele = $(this);

            var user_data = $ele.closest('div.result_table');
            var duid = user_data.data('duid');

            $.get('/members/msg/get_thread_json/', { duid: duid })
                .done(function(thread_json) {
                    vent.trigger('MessagePane:send_message', duid, thread_json);
                });
        });

        // flirt match popup
        $('.search-controls-wrap').on("click", ".flirt-match-btn", function(e){
            GP.vent.trigger('Modal:open', {url: "/members/user/flirt/"});
/*
            $('#flirt_box').modal({
                backdrop: 'static',
                keyboard: false,
                show: true
            });
*/
            e.stopImmediatePropagation();
            return false;
        });

        $('#search-main').on("click", ".btn-search-toggle", function(e){

            var class_to_add = ($('#advanced_hidden').val() == 1) ? 'show-advanced-search' : '';
            $('#search-main').toggleClass('show-search-form ' + class_to_add);
            $('#search-main').removeClass('show-search-summary');
            e.stopImmediatePropagation();
            return false;
        });

        $('#search-main').on("click", ".js-search-nav", function(e){
            $('#search-form-wrap').toggleClass('hidden');
            $('body').toggleClass('search-panel-shown');
        });

        $('#search-main').on("click", ".btn-list-toggle", function(e){
						$(this).addClass('on');
						$(this).attr('disabled', 'disabled');
            $('.btn-grid-toggle').removeClass('on');
            $('.btn-grid-toggle').removeAttr('disabled');
            $('.search-results-wrap').removeClass('grid');
            $('.search-results-wrap').addClass('list');
            e.stopImmediatePropagation();
            GP.Util.set_cookie('fl_search_grid', 'list', 7);
            return false;
        });

        $('#search-main').on("click", ".btn-grid-toggle", function(e){
						$(this).addClass('on');
						$(this).attr('disabled', 'disabled');
            $('.btn-list-toggle').removeClass('on');
            $('.btn-list-toggle').removeAttr('disabled');
            $('.search-results-wrap').removeClass('list');
            $('.search-results-wrap').addClass('grid');
            e.stopImmediatePropagation();
            GP.Util.set_cookie('fl_search_grid', 'grid', 7);
            return false;
        });

        $('#search-main').on("click", ".btn-search-back", function(e){
            self.reset_search_type();
            $('#search-main').removeClass('show-search-form');
            e.stopImmediatePropagation();
            return false;
        });
        
        $('#search-main').on("click", ".btn-search-cancel", function(e){
            self.reset_search_type();
            $('#search-main').removeClass('show-search-form');
            e.stopImmediatePropagation();
            return false;
        });

        $('#search-main').on("click", ".btn-advanced-search", function(e){
            self.reset_search_type();
            $('#search-main').addClass('show-advanced-search');
            $('#advanced_hidden').val(1);
            e.stopImmediatePropagation();
            return false;
        });

        $('#search-main').on("click", ".btn-username-toggle", function(e){
            self.reset_search_type();
            $('#search-main').addClass('show-username-search');
            $('#username_hidden').val(1);
            window.scrollTo(0,0);
            e.stopImmediatePropagation();
            return false;
        });

        // Desktop view search tabs
        $('#search-main').on("click", ".search-form-tabs a", function(e){
            var search_tab = $(this).data('search');
            self.reset_search_type();

            $('.search-form-tabs li').removeClass('active');
            $(this).closest('li').addClass('active');

            if (search_tab == 'advanced') {
                $('#advanced_hidden').val(1);
                $('#search-main').addClass('show-advanced-search');
            } else if (search_tab == 'username') {
                $('#username_hidden').val(1);
                $('#search-main').addClass('show-username-search');
            }

            e.stopImmediatePropagation();
            return false;
        });

        $('.btn-search-form-group').on('click', function(e) {
            e.preventDefault();
            $(this).find('.icon-close').toggleClass('hidden');
            $(this).find('.icon-open').toggleClass('hidden');
            $(this).closest('.search-form-section').find('.search-filter-section').toggleClass('hidden');
        });

        //--------------- SEARCH.POPULAR SPECIFIC ------------------//
        $('#search-main').on("change", ".search-filter-popular select", function(e) {
            var filters = '';
            $('.search-filter-popular select').each(function(i) {
                var val = $(this).find('option:selected').val();
                if (val) {
                    filters += '&'+$(this).attr('id')+'='+val;
                }
            });
            if (filters) {
                filters = filters.replace('body-type', 'body_type');
                window.location = '/members/search/quicksearch/?search_type=popular'+filters;
            } else {
                window.location = '/members/search/quicksearch/?search_type=popular';
            }
        });

        $('#search-main').on("click", "#btn-filter-popular", function(e){
            var $filter_container = $(".search-filter-popular");
            $filter_container.toggleClass("popover bottom");

            $('#search-main').on("click.search-filter-popover", function(e){
                if (!$(e.target).parents().is(".popover")) {
                    $filter_container.toggleClass("popover bottom");
                    $('#search-main').off("click.search-filter-popover");
                }

            });

            e.stopImmediatePropagation();
            return false;
        });

        //--------------- SEARCH.USER_STATUS ------------------//
        $('#search-main').on("change", "#filter-user-status", function(e) {
            var qs_param = '';
            var val = $(this).find('option:selected').val();
            if (val) {
                qs_param = '&status_id=' + val;
            }

            if (qs_param) {
                window.location = '/members/search/quicksearch/?search_type=user_status' + qs_param;
            } else {
                window.location = '/members/search/quicksearch/?search_type=user_status';
            }
        });



        $('#search-main').on("click", ".actions_overlay .close_button", function(e){
            e.preventDefault();
            $(this).closest('.actions_overlay').stop(true).hide();
            $(this).closest('.actions-overlay-inner').find('.quick-message-wrap').empty();
        });

        $('#search-main').on("click", ".search_send_message", function(e){
            e.preventDefault();
            $('.actions_overlay').hide();

            var duid = $(this).data('duid');
            var _username = $(this).closest('.search-result-content').data('username');

            var overlay = $("#actions_overlay_" + duid);
            overlay.addClass('overlay-send-chat');
            overlay.find('.icon').html('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"><path d="M6.09436 11.2288C6.03221 10.8282 5.99996 10.4179 5.99996 10C5.99996 5.58172 9.60525 2 14.0526 2C18.4999 2 22.1052 5.58172 22.1052 10C22.1052 10.9981 21.9213 11.9535 21.5852 12.8345C21.5154 13.0175 21.4804 13.109 21.4646 13.1804C21.4489 13.2512 21.4428 13.301 21.4411 13.3735C21.4394 13.4466 21.4493 13.5272 21.4692 13.6883L21.8717 16.9585C21.9153 17.3125 21.9371 17.4895 21.8782 17.6182C21.8266 17.731 21.735 17.8205 21.6211 17.8695C21.4911 17.9254 21.3146 17.8995 20.9617 17.8478L17.7765 17.3809C17.6101 17.3565 17.527 17.3443 17.4512 17.3448C17.3763 17.3452 17.3245 17.3507 17.2511 17.3661C17.177 17.3817 17.0823 17.4172 16.893 17.4881C16.0097 17.819 15.0524 18 14.0526 18C13.6344 18 13.2237 17.9683 12.8227 17.9073M7.63158 22C10.5965 22 13 19.5376 13 16.5C13 13.4624 10.5965 11 7.63158 11C4.66668 11 2.26316 13.4624 2.26316 16.5C2.26316 17.1106 2.36028 17.6979 2.53955 18.2467C2.61533 18.4787 2.65322 18.5947 2.66566 18.6739C2.67864 18.7567 2.68091 18.8031 2.67608 18.8867C2.67145 18.9668 2.65141 19.0573 2.61134 19.2383L2 22L4.9948 21.591C5.15827 21.5687 5.24 21.5575 5.31137 21.558C5.38652 21.5585 5.42641 21.5626 5.50011 21.5773C5.5701 21.5912 5.67416 21.6279 5.88227 21.7014C6.43059 21.8949 7.01911 22 7.63158 22Z"/></svg>');
            overlay.find('.title').text('Send Message');
            overlay.find('.actions_overlay_content').html($('#fragment_send_message').html());
            overlay.find('.text-username').text(_username);
            overlay.find('form input[name="to_duid"]').val(duid);
            overlay.fadeIn();
            overlay.find('textarea').focus();
        });

        $('#search-main').on('submit', '.search_send_message_form', function(e) {
            e.preventDefault();

            var $form = $(this);
            var duid  = $form.find('input[name="to_duid"]').val();

            var form_data = $form.serialize();
            var button = $('#search_send_message_' + duid);
            var overlay = $form.parents('.actions_overlay');
            $.post('/members/msg/add_message/', form_data, function(data) {
                var max_threads_error = false;
                if (data.hasOwnProperty("max_free_restricted_state_threads_reached")) {
                    overlay.find('.actions_overlay_content').html($('#fragment_free_restricted_state_message_limit').html());
                    max_threads_error = true;
                } else if (data.hasOwnProperty("max_free_threads_reached")) {
                    overlay.find('.actions_overlay_content').html($('#fragment_free_message_limit').html());
                    overlay.find('.search_send_message_form').hide();
                    max_threads_error = true;
                } else if (data.hasOwnProperty("error")) {
                    if ($.isArray(data.error)) {
                        $.each(data.error, function(i,v) {
                            if (v == 'free message limit exceeded') {
                                overlay.find('.actions_overlay_content').html($('#fragment_free_message_limit').html());
                                overlay.find('.search_send_message_form').hide();
                                max_threads_error = true;
                            }
                        });
                    }
                }

                if (max_threads_error) {
                    $('.search_send_message').off('click').hide();
                    $('.quick_chat').off('click').hide();
                    $('.send_wink').show();
                }
                if (!max_threads_error) {
                    overlay.find('.actions_overlay_content').html($('#fragment_error').html());
                }

                if (data.status && !max_threads_error) {
                    overlay.find('.actions_overlay_content').html($('#fragment_message_sent').html());
                    button.text(language.search_message_sent).addClass('disabled').off('click');
                }
                setTimeout(function() { overlay.hide().removeClass('overlay-send-chat'); }, 5000);
            });
        });

        $('#search-main').on('click', '#search-main .search-result', function(e) {
            self.handle_search_result_click($(this), e);
        });
        $('#search-main').on('click', '#search-main .search-result-grid', function(e) {
            self.handle_search_result_click($(this), e);
        });

        if (typeof search_tab != 'undefined' && MoshPit.get_size() != 'mobile') {
            if (search_tab == 'advanced') {
                $('#search-main').addClass('show-search-form');
                $('#advanced_tab a').trigger('click');
            } else if (search_tab == 'username') {
                $('#username_tab a').trigger('click');
            }
        }

        update_interest_pills($('#search-interest-select').val());

        if (check_search_changed()) {
            let changed_storage = JSON.parse(localStorage.getItem("searched_changed_inputs"));
            changed_inputs = (changed_storage === null) ? {} : changed_storage;

            update_search_local_storage(changed_inputs);
            show_section_indicator();
        } else {
            // clear changed inputs local storage
            update_search_local_storage({});
        }

        if (check_update_selected()) {
            $('#search-interest-select').trigger('change');
            update_search_local_storage(changed_inputs);
            show_section_indicator();
        }

        // main quicksearch form submit handler (used by everything except popular)
        $('#search-main').on('submit', 'form#search-form-list', function(e) {
            e.preventDefault();

            if ($('#username_hidden').val() == 1) {
                if ($('#username_text').val().length < 3) {
                    $('#username_length_error').show();
                    return;
                } else {
                    $('#username_length_error').hide();
                }
            }

            update_search_local_storage(changed_inputs);

            var form_data = $(this).serialize();
            // backbone router.navigate does not change the page if the url is unchanged. this feels broken for the user when they click search
            // GP.vent.trigger('Page:redirect', '/members/search/quicksearch/?' + form_data);
            window.location = '/members/search/quicksearch/?' + form_data;
        });

        GP.vent.trigger('User:setup_verified_tooltip', $('.search-result .verified'));
    });

    var _picker_row_size = GP.sdata.is_mobile ? 5 : 10;
    $('#search-interest-select').selectpicker({
        maxOptions: 5,
        size:       _picker_row_size,
        liveSearch: true,
        dropupAuto: false,
        width: '100%',
        style: 'rounded-md border-0 py-1.5 pl-3 w-full text-gray-900 text-sm shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600'
    });

    $('#search-interest-select').on('change', function(e) {
        let interests = $(this).val();
        update_interest_pills(interests);

        let input_name = $(this).attr('name');
        if (interests === null) {
            remove_changed_inputs(input_name);
        } else {
            update_changed_inputs(input_name, interests);
        }
    });

    $('#search-interest-reset').on('click', function(e) {
        handle_interests_reset();
    });

    $('.js-form-changes').on('change', function(e) {
        let $form_el = $(this);
        let input_type = $form_el.attr('type');
        let input_name = $form_el.attr('name');
        let input_val  = $form_el.val();

        if (input_type === 'checkbox') {
            if ($('input[name="' + input_name + '"]:checked').length > 0) {
                update_changed_inputs(input_name, input_val);
            } else {
                remove_changed_inputs(input_name);
            }
        } else if (input_val.length === 0) {
            remove_changed_inputs(input_name);
        } else {
            update_changed_inputs(input_name, input_val);
        }
    });

    $('#search-main').on('click', '.js-interest-pill', function(e) {
        $('#search-interest-select').find('option[value="' + $(this).data('value') + '"]').prop('selected', false);
        $('#search-interest-select').trigger('change');
    });
}

function update_search_local_storage(input_obj) {
    if (input_obj !== null) {
        localStorage.setItem("searched_changed_inputs", JSON.stringify(input_obj));
    }
}

function update_changed_inputs(key, val) {
    let ignored_inputs = [
        "start_age",
        "end_age",
        "online_now",
        "onchat",
        "photos_only",
        "streaming",
        "pic_verified",
    ];

    if (!ignored_inputs.includes(key)) {
        changed_inputs[key] = val;
    }
}

function remove_changed_inputs(input_key) {
    delete changed_inputs[input_key];
}

function update_interest_pills(interests) {
    let interest_wrap = $('.selected-interest-wrap');
    interest_wrap.find('.interest-pill').remove();
    $(interests).each(function(index, option_val) {
        let interest_text = $('#search-interest-select option[value="' + option_val + '"]').text();
        let pill_template = $($('#template-interest-pill').html());

        pill_template.find('.text-interest').text(interest_text);
        pill_template.attr('data-value', option_val);
        interest_wrap.prepend(pill_template);
    });

    if (interests) {
        let count = interests.length;

        if (count > 0) {
            update_interest_count(count);
            show_interest_reset_btn();
        }
    } else {
        update_interest_count(0);
        hide_interest_reset_btn();
    }    
}

function show_section_indicator() {
    const stored_search_inputs = JSON.parse(localStorage.getItem("searched_changed_inputs"));
    if (Object.keys(stored_search_inputs).length !== 0) {
        for (const [key, value] of Object.entries(stored_search_inputs)) {
            let filter_section = $('#search-main')
            .find('[name="' + key + '"]')
            .closest('.search-form-section');

            filter_section.find('.form-indicator').removeClass('hidden');
        }
        show_mobile_search_indicator();
    }
}

function show_mobile_search_indicator() {
    $('#js-nav-indicator').removeClass('hidden');
}

function check_search_changed() {
    let location_qs = window.location.search;
    if (location_qs) {
        let search_params = new URLSearchParams(location_qs);
        // search results from submitted form
        if (search_params.has('process')) {
            return true;
        }
    }
    return false;
}

function check_update_selected() {
    let location_qs = window.location.search;
    if (location_qs) {
        let search_params = new URLSearchParams(location_qs);

        if (search_params.has('update_selected')) {
            // $('#search-interest-select').trigger('change');
            return true;
        }
    }
    return false;
}

function store_initial_search_state() {
    $('#search-main :input').each(function () {
        const input = $(this);
        if (input.attr('name')) {
            initial_search_state[input.attr('name')] = input.val();
        }
    });
}

function handle_interests_reset() {
    hide_interest_reset_btn();
    $('.selected-interest-wrap').find('.interest-pill').remove();

    // deselect interests
    $("#search-interest-select option:selected").prop("selected", false);
    $('#search-interest-select').selectpicker('deselectAll');
}

function show_interest_reset_btn() {
    $('#search-interest-reset').removeClass('hidden');
}
function hide_interest_reset_btn() {
    $('#search-interest-reset').addClass('hidden');
}

function update_interest_count(count) {
    $('.search-interest-count').text(count);

    $('#form-group-interests input[name="interests[]"]').each(function() {
        if ($(this).is(':checked')) {
            interest_count = interest_count + 1;
            self.update_interests_total_text();
        }
    });

}
